/* ===================== MORDAÇA — interações (produção) ===================== */
(function () {
  "use strict";

  /* ---- Reveal ao rolar ---- */
  const revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach((el, i) => {
      el.style.transitionDelay = Math.min(i % 4, 3) * 70 + "ms";
      io.observe(el);
    });
  } else {
    revealEls.forEach((el) => el.classList.add("in"));
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll(".qa button").forEach((btn) => {
    btn.addEventListener("click", () => {
      const qa = btn.closest(".qa");
      const ans = qa.querySelector(".ans");
      const open = qa.classList.contains("open");
      document.querySelectorAll(".qa.open").forEach((o) => {
        o.classList.remove("open");
        o.querySelector(".ans").style.maxHeight = null;
      });
      if (!open) {
        qa.classList.add("open");
        ans.style.maxHeight = ans.scrollHeight + "px";
      }
    });
  });

  /* ---- CTA dos planos ---------------------------------------------------
     Cada botão de plano tem data-checkout="" — cole aí a URL de checkout
     da Shopify (ex.: https://sualoja.myshopify.com/cart/VARIANT_ID:1).
     Enquanto estiver vazio, mostra um feedback visual de "adicionado".  */
  document.querySelectorAll(".add-cart").forEach((btn) => {
    const original = btn.textContent;
    btn.addEventListener("click", (e) => {
      const url = btn.getAttribute("data-checkout");
      if (url && url.trim()) { return; /* deixa o link <a> seguir normalmente */ }
      e.preventDefault();
      btn.textContent = "✓ Adicionado";
      btn.style.background = "var(--bone)";
      btn.style.color = "var(--ink)";
      btn.style.borderColor = "var(--bone)";
      setTimeout(() => {
        btn.textContent = original;
        btn.style.background = "";
        btn.style.color = "";
        btn.style.borderColor = "";
      }, 1400);
    });
  });

  /* ---- Barra de compra fixa ----
     Regra: a barra aparece sempre que o hero saiu da tela E os planos não
     estão visíveis. A versão anterior usava dois observers independentes que
     só se falavam na transição: depois que o usuário passava da seção de
     planos, nada religava a barra, e ela ficava escondida no resto da página
     (garantia, FAQ, CTA final) — justamente onde a intenção de compra volta. */
  const buybar = document.getElementById("buybar");
  const hero = document.querySelector(".hero");
  if (buybar && hero && "IntersectionObserver" in window) {
    const planos = document.getElementById("planos");
    let heroVisible = true;
    let planosVisible = false;

    const sync = () => buybar.classList.toggle("show", !heroVisible && !planosVisible);

    const heroIO = new IntersectionObserver((entries) => {
      entries.forEach((e) => { heroVisible = e.isIntersecting; });
      sync();
    }, { threshold: 0 });
    heroIO.observe(hero);

    if (planos) {
      /* observa o card inteiro, não só a âncora, pra barra não piscar
         enquanto o usuário está de fato lendo os planos */
      const planosEl = planos.closest(".plans") || planos;
      const pIO = new IntersectionObserver((entries) => {
        entries.forEach((e) => { planosVisible = e.isIntersecting; });
        sync();
      }, { threshold: 0.15 });
      pIO.observe(planosEl);
    }
    sync();
  }

  /* ---- Formulários (contato / atacado) ---- */
  document.querySelectorAll("form.form").forEach((form) => {
    form.addEventListener("submit", (e) => {
      /* No Shopify, o {% form 'contact' %} tem action: deixa enviar de verdade. */
      if (form.getAttribute("action")) return;
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      form.classList.add("sent");
      const btn = form.querySelector("[type=submit]");
      if (btn) { btn.disabled = true; btn.textContent = "✓ Enviado"; }
      form.reset();
      setTimeout(() => { form.classList.remove("sent"); if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || "Enviar"; } }, 4000);
    });
  });

  /* ---- Antes / Depois: arrastar ---- */
  const ba = document.getElementById("ba");
  if (ba) {
    const after = ba.querySelector(".after");
    const handle = document.getElementById("baHandle");
    let dragging = false;

    function setSplit(clientX) {
      const r = ba.getBoundingClientRect();
      let pct = ((clientX - r.left) / r.width) * 100;
      pct = Math.max(4, Math.min(96, pct));
      ba.style.setProperty("--split", pct + "%");
      after.style.clipPath = "inset(0 0 0 " + pct + "%)";
    }
    ba.style.setProperty("--split", "50%");
    after.style.clipPath = "inset(0 0 0 50%)";

    const start = () => { dragging = true; document.body.style.userSelect = "none"; };
    const end = () => { dragging = false; document.body.style.userSelect = ""; };
    const move = (x) => { if (dragging) setSplit(x); };

    handle.addEventListener("pointerdown", (e) => { start(); handle.setPointerCapture(e.pointerId); });
    window.addEventListener("pointermove", (e) => move(e.clientX));
    window.addEventListener("pointerup", end);
    ba.addEventListener("pointerdown", (e) => { if (e.target !== handle) setSplit(e.clientX); });
  }

  /* ---- Zoom da foto hero (lightbox) ---- */
  function openImgZoom(src, alt) {
    const ov = document.createElement("div");
    ov.className = "img-zoom-overlay";
    const close = document.createElement("button");
    close.className = "img-zoom-close";
    close.setAttribute("aria-label", "Fechar");
    close.textContent = "×";
    const im = document.createElement("img");
    im.src = src;
    im.alt = alt || "";
    ov.appendChild(close);
    ov.appendChild(im);
    document.body.appendChild(ov);
    document.body.style.overflow = "hidden";
    requestAnimationFrame(() => ov.classList.add("open"));
    const onKey = (e) => { if (e.key === "Escape") closeZoom(); };
    function closeZoom() {
      ov.classList.remove("open");
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
      setTimeout(() => ov.remove(), 200);
    }
    ov.addEventListener("click", (e) => {
      if (e.target === ov || e.target.closest(".img-zoom-close")) closeZoom();
    });
    document.addEventListener("keydown", onKey);
  }
  document.addEventListener("click", (e) => {
    const img = e.target.closest(".hero-visual .frame img");
    if (!img) return;
    e.preventDefault();
    openImgZoom(img.currentSrc || img.src, img.alt);
  });
})();
